"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgAttachFile(props) {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M19.395 12.345l-7.4 8.218c-5.327 5.916 2.905 13.328 8.232 7.412l8.287-9.204c3.552-3.945-1.936-8.886-5.488-4.941l-8.287 9.203c-2.071 2.301.673 4.772 2.744 2.47l7.4-8.217", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0) }), void 0));
}
exports.default = SvgAttachFile;
//# sourceMappingURL=AttachFile.js.map